import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-default",
  class PredictiveSearchResultDefault extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);
      this.link = this.querySelector("a");

      this.setText();
      this.setHref();

      this.addEventListener("click", this.handleClick.bind(this));
    }

    setText() {
      /* Name may contain HTML entities like &amp; */
      this.link.innerHTML = this.data.name;
    }

    setHref() {
      this.link.href = this.data.url;
    }

    handleClick() {
      if (
        !IntelliSuggest ||
        !this.data.intellisuggestData ||
        !this.data.intellisuggestSignature
      ) {
        return;
      }

      IntelliSuggest.clickItem(this, {
        siteId: WYATT.config.searchspring.siteIds.collections,
        intellisuggestData: this.data.intellisuggestData,
        intellisuggestSignature: this.data.intellisuggestSignature,
      });
    }
  },
);
